import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Tokelau: Country = {
    identifier: "Tokelau",
    name: "Tokelau",
    countryCode: "TK",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇹🇰",
    svgPath: "m 1001.1707,486.9334 -0.013,0.006 -0.013,-0.032 -0.017,-0.035 -0.013,-0.032 0,-0.004 0.027,0.027 0.018,0.032 0.01,0.038 z m 3.628,2.187 -0.01,0.008 -0.013,-0.017 -0.02,-0.022 -0.013,-0.032 0.01,-0.002 0.021,0.018 0.015,0.022 0.01,0.025 z",
}
